import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=358a87fd&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=358a87fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358a87fd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BodyArticleBanner: require('/builds/clients/agily/agily-website-v2/front/components/Body/ArticleBanner.vue').default,BodyArticleContent: require('/builds/clients/agily/agily-website-v2/front/components/Body/ArticleContent.vue').default,BodyArticlesList: require('/builds/clients/agily/agily-website-v2/front/components/Body/ArticlesList.vue').default,BodyComponents: require('/builds/clients/agily/agily-website-v2/front/components/BodyComponents.vue').default,GlobalsLink: require('/builds/clients/agily/agily-website-v2/front/components/Globals/Link.vue').default})
